import { participantInstance } from "./api";
const url = process.env.REACT_APP_BASE_URL || "/";

// call api to get the ict inventory details
async function getIctInventoryDetails(inventory_id) {
  const api = url + `/participants/ict/inventories/${inventory_id}/details`;
  return await participantInstance
    .get(api)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}
// add the inventory partial answers
async function addIctInventoryPartialAnswers(inventory_id, data) {
  const api = url + `/participants/ict/inventories/${inventory_id}/answer-save`;

  return await participantInstance
    .post(api, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

// get the inventory partial answers
async function getIctInventoryPartialAnswers(inventory_id) {
  const api = url + `/participants/ict/inventories/${inventory_id}/answer`;

  return await participantInstance
    .get(api)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

// call the api for add inventory answer
async function addIctInventoryAnswer(inventory_id, data) {
  const api = url + `/participants/ict/inventories/${inventory_id}/responses`;

  return await participantInstance
    .post(api, data)
    .then((response) => {
      //retun status 1 for success
      return response;
    })
    .catch((error) => {
      //return error
      return error.response;
    });
}

// call the api for getting the result of an inventory
async function getIctInventoryAnswer(inventory_id) {
  const api = url + `/participants/ict/inventories/${inventory_id}/scores`;

  return await participantInstance
    .get(api)
    .then((response) => {
      //retun status 1 for success
      return response;
    })
    .catch((error) => {
      //return error
      return error.response;
    });
}


async function updateIctInventoryAnswerPage(inventory_id, dataToSave) {
  const api =
    url +
    `/participants/ict/inventories/${inventory_id}/page`;

  return await participantInstance
    .put(api, dataToSave)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

async function getIctInitialInventoryResponse(inventory_id) {
  const api =
    url +
    `/participants/ict/inventories/${inventory_id}/scores`;

  return await participantInstance
    .get(api)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}
// get the evaluation details
async function getIctEvaluationDetails(workshop_id) {
  const api = url + `/participants/ict/evaluations/${workshop_id}/details`;
  return await participantInstance
    .get(api)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}
// call the api for add evaluation answer
async function addIctEvaluationAnswer(workshop_id, data) {
  const api = url + `/participants/ict/evaluations/${workshop_id}/responses`;
  return await participantInstance
    .post(api, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}
// add the evaluation partial answers
async function addIctEvaluationPartialAnswers(workshop_id, data) {
  const api = url + `/participants/ict/evaluations/${workshop_id}/answer-save`;

  return await participantInstance
    .post(api, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });  
}
// get the evaluation partial answers
async function getIctEvaluationPartialAnswers(workshop_id) {
  const api = url + `/participants/ict/evaluations/${workshop_id}/answer`;
  return await participantInstance
    .get(api)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}
async function updateIctEvaluationAnswerPage(workshopId, dataToSave) {
  const api =
    url +
    `/participants/ict/evaluations/${workshopId}/page`;

  return await participantInstance
    .put(api, dataToSave)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}
// call the api for getting the result of an evaluation
async function getIctEvaluationAnswer(workshop_id) {
  const api =
    url +
    `/participants/ict/evaluations/${workshop_id}/responses`;

  return await participantInstance
    .get(api)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

async function getIctFollowupDetails(followup_id) {
  const api = url + `/participants/ict/followups/${followup_id}/details`;
  return await participantInstance
    .get(api)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

async function addIctFollowupPartialAnswers(followup_id, data) {
  const api = url + `/participants/ict/followups/${followup_id}/answer-save`;
  return await participantInstance
    .post(api, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
};

async function getIctFollowupPartialAnswers(followup_id) {
  const api = url + `/participants/ict/followups/${followup_id}/answer`;
  return await participantInstance
    .get(api)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

async function addIctFollowupSubmitAnswers(followup_id, data) {
  const api = url + `/participants/ict/followups/${followup_id}/responses`;
  return await participantInstance
    .post(api, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

async function getIctFollowupResponse(followup_id) {
  const api = url + `/participants/ict/followups/${followup_id}/responses`;
  return await participantInstance
    .get(api)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}
async function updateIctFollowupAnswerPage(followupId, dataToSave) {
  const api =
    url +
    `/participants/ict/followups/${followupId}/page`;

  return await participantInstance
    .put(api, dataToSave)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}
export const ictDetailsService = {
  getIctInventoryDetails,
  addIctInventoryAnswer,
  getIctInventoryAnswer,
  addIctInventoryPartialAnswers,
  getIctInventoryPartialAnswers,
  updateIctInventoryAnswerPage,
  getIctInitialInventoryResponse,
  getIctEvaluationDetails,
  addIctEvaluationPartialAnswers,
  getIctEvaluationPartialAnswers,
  addIctEvaluationAnswer,
  getIctEvaluationAnswer,
  getIctFollowupDetails,
  addIctFollowupPartialAnswers,
  getIctFollowupPartialAnswers,
  addIctFollowupSubmitAnswers,
  getIctFollowupResponse,
  updateIctEvaluationAnswerPage,
  updateIctFollowupAnswerPage,
};
